import { Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { FormValidation } from '../../../shared/forms/form-validation';
import { ClaimsAppSubmissionConstant } from '../models/claims-app-submission.constant';
import { maxDateValidator } from '../../../shared/custom-validators/max-date.directive';
import { FormObjectComponent } from '../../../shared/forms/form-object.component';

@Component({
  selector: 'claims-app-mechanical-breakdown',
  templateUrl: './claims-app-mechanical-breakdown.component.html',
})
export class ClaimsAppMechanicalBreakdownComponent extends FormObjectComponent implements OnInit {
  public override form: UntypedFormGroup;  
  
  public readonly minCurrentOdometer = 0;
  public readonly maxCurrentOdometer = 999999;
  
  public readonly driveIn = ClaimsAppSubmissionConstant.driveIn;
  public readonly towedIn = ClaimsAppSubmissionConstant.towedIn;
  public hasTransportationMode = true;
  public today = new Date();

  public faInfo = faCircleQuestion;
  
  ngOnInit(): void {
    
    this.form = new UntypedFormGroup({
      'breakdownDate': new UntypedFormControl("", [Validators.required, maxDateValidator(this.today)]),
      'currentOdometer': new FormControl<number>(null, [Validators.required,
                                                        Validators.min(this.minCurrentOdometer),
                                                        Validators.max(this.maxCurrentOdometer)]),
      'transportationMode': new UntypedFormControl(null, [Validators.required]),
      'isCollision': new FormControl<boolean>(false), 
      'hasModification': new FormControl<boolean>(false), 
      'IsCommercialUse': new FormControl<boolean>(false), 
      'repairOrderNumber': new UntypedFormControl("", [Validators.required, Validators.maxLength(30)]),
    });
  }

  public validateTransportationMode(): void {
    var transportationModeValue = this.form.controls['transportationMode']?.value;
    this.hasTransportationMode = transportationModeValue !== null
                                 && transportationModeValue !== undefined;
  }

  //** Validates the customer form and sets formCompleted to valid or invalid */
  public override validateForm(): void {
    this.validateTransportationMode();

    this.formCompleted = FormValidation.isValid(this.form)
                         && this.hasTransportationMode;
  }
}
